import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { SpotIcon } from "../icons/spot-icon/SpotIcon";
import { SpotIconBackgroundSunset } from "../icons/spot-icon/SpotIconBackgroundSunset";
import { SpotIconForegroundCircleDashes } from "../icons/spot-icon/SpotIconForegroundCircleDashes";
import { SpotIconForegroundCircleExclamation } from "../icons/spot-icon/SpotIconForegroundCircleExclamation";
import { SpotIconForegroundCirclePlus } from "../icons/spot-icon/SpotIconForegroundCirclePlus";
import { SpotIconForegroundFolder } from "../icons/spot-icon/SpotIconForegroundFolder";
import { SpotIconForegroundMagnifyingGlass } from "../icons/spot-icon/SpotIconForegroundMagnifyingGlass";
import { SpotIconForegroundShieldLock } from "../icons/spot-icon/SpotIconForegroundShieldLock";
import { SpotIconForegroundSignalExclamation } from "../icons/spot-icon/SpotIconForegroundSignalExclamation";
import * as Styled from "./EmptyState.styled";
export const MESSAGE_ICON_COMPONENTS = {
    configError: SpotIconForegroundCircleExclamation,
    connectionError: SpotIconForegroundSignalExclamation,
    genericError: SpotIconForegroundCircleExclamation,
    emptyState: SpotIconForegroundFolder,
    emptyStateAdd: SpotIconForegroundCirclePlus,
    generic: SpotIconForegroundCircleDashes,
    notFound: SpotIconForegroundMagnifyingGlass,
    permissionDenied: SpotIconForegroundShieldLock,
    searchResults: SpotIconForegroundMagnifyingGlass
};
const getValue = (valueToGet) => {
    if (typeof valueToGet === "string") {
        return _jsx("p", { children: valueToGet });
    }
    return valueToGet;
};
const getIcon = (messageType, icon, size) => {
    if (icon) {
        return icon;
    }
    const Icon = MESSAGE_ICON_COMPONENTS[messageType] || SpotIconForegroundCircleExclamation;
    return (_jsx(SpotIcon, { size: size, hasSparkles: false, background: _jsx(SpotIconBackgroundSunset, { "aria-hidden": "true" }), foreground: _jsx(Icon, { "aria-hidden": "true" }) }));
};
export const EmptyState = forwardRef(({ message, messageType = "generic", details, icon, size, ...otherProps }, ref) => (_jsxs(Styled.EmptyState, { ref: ref, "data-testid": "EmptyState", ...otherProps, children: [_jsx(Styled.IconWrapper, { children: getIcon(messageType, icon, size) }), _jsx(Styled.Message, { children: message && getValue(message) }), _jsx(Styled.DetailsWrapper, { children: details && getValue(details) })] })));
EmptyState.displayName = "EmptyState";
EmptyState.defaultProps = {
    messageType: "generic"
};
